<template>
    <div class="mfa-setup-form">
        <div class="row">
            <div class="col-md-6">

                <div>
                    <h3>Step 1</h3>

                    <div>
                        Please download and install the Microsoft Authenticator app to your mobile device.
                        Based on whether your device is Android or iOS, you can download the app by clicking
                        on your app store below.

                        <div class="app-buttons">
                            <a
                                href="https://apps.apple.com/us/app/microsoft-authenticator/id983156458"
                                target="_blank"
                                rel="noreferrer noopener"
                                class="btn btn-dark"
                            >
                                <i class="fab fa-apple"></i> Apple Store
                            </a>

                            <a
                                href="https://play.google.com/store/apps/details?id=com.azure.authenticator"
                                target="_blank"
                                rel="noreferrer noopener"
                                class="btn btn-success"
                            >
                                <i class="fab fa-google-play"></i> Google Play Store
                            </a>
                        </div>

                    </div>
                </div>

                <h3>Step 2</h3>

                <div>
                    <div>After the Authenticator app is set up on your device, please follow the instructions for
                        your
                        device below:
                    </div>

                    <div class="row">
                        <div class="col-md-6">
                            <strong>On Apple devices</strong>
                            <ol>
                                <li>Click on the <i class="fas fa-plus"></i> sign.</li>
                                <li>Select "Other (Google, Facebook, etc.)"</li>
                                <li>Scan the QR code with the application</li>
                            </ol>
                        </div>

                        <div class="col-md-6">
                            <strong>On Android devices</strong>
                            <ol>
                                <li>Click on the <i class="fas fa-ellipsis-v"></i> sign.</li>
                                <li>Select "Other Account (Google, Facebook, etc.)"</li>
                                <li>Scan the QR code with the application</li>
                            </ol>
                        </div>
                    </div>
                </div>

                <h3>Step 3</h3>

                <div>
                    After QR code is scanned successfully, please enter the code you see on your Authenticator app
                    to the field below and click on "Verify code" to finish the setup:

                    <div v-if="!isLoading">
                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group">
                                    <input type="text"
                                           v-model="form.authenticator_code"
                                           placeholder="Code"
                                           class="form-control"
                                           @keydown="handleConfirmViaEnter"
                                    >
                                    <div class="error-help" v-if="errorMessage.length > 0">{{ errorMessage }}</div>
                                </div>
                            </div>
                        </div>

                        <button class="btn btn-primary" :disabled="v$.$invalid" @click="handleConfirm">Verify code
                        </button>
                    </div>
                    <div v-else>
                        <Loader wait-text="Verifying..."/>
                    </div>
                </div>
            </div>

            <div class="col-md-6">
                <div>
                    <div class="text-center">
                        <img src="/mfa/generate" alt="Your Authenticator QR Code">
                    </div>
                </div>
            </div>
            <div>&nbsp;</div>
        </div>
    </div>
</template>

<script>
import required from "vuelidate/lib/validators/required";
import { useForm } from "@/hooks/use-form";

import Loader from "@/components/Loader.vue";

export default {
    name: "MfaAppSetupForm",
    components: { Loader },
    props: {
        isLoading: Boolean,
        errorMessage: String,
        type: String,
    },
    setup(props, { emit }) {

        const { form, v$ } = useForm({
            props: {
                authenticator_code: ''
            },
            rules: {
                authenticator_code: { required }
            }
        });

        const handleConfirm = async () => {
            if (v$.value.$invalid) {
                return;
            }

            emit('confirmed', {
                code: form.authenticator_code,
                type: props.type,
            });
        };

        const handleConfirmViaEnter = (e) => {
            if (e.key === "Enter" || e.key === "Return") {
                handleConfirm();
            }
        };

        return {
            handleConfirmViaEnter,
            handleConfirm,
            form,
            v$
        }
    }
}
</script>

<style scoped lang="scss">
.mfa-setup-form {
    h3 {
        font-size: 16px;
        font-weight: bold;
    }

    .app-buttons {
        text-align: center;
        padding-top: 15px;
        padding-bottom: 15px;

        a {
            display: inline-block;
            margin-right: 5px;
        }
    }

    .error-help {
        color: red;
    }
}
</style>